export enum IdentityType {
  CITIZEN_IDENTIFICATION_CARD = 'citizen_identification_card',
  ID_CARD = 'id_card',
  PASSPORT = 'passport',
}
export const identityTypeOptions = [
  {
    label: 'CCCD',
    value: IdentityType.CITIZEN_IDENTIFICATION_CARD,
  },
  {
    label: 'CMND',
    value: IdentityType.ID_CARD,
  },
  {
    label: 'Hộ chiếu',
    value: IdentityType.PASSPORT,
  },
];
